(() => {
  // app/scripts/store-drawer-component.js
  var storeDrawerComponent = class extends HTMLElement {
    constructor() {
      super();
      this.productPrice = this.dataset.productPrice;
      this.hasSpecial = this.dataset.hasSpecial;
      this.productSelect = this.dataset.productSelect;
      this.container = this.closest('[data-section-type="popup-store-location"]');
      this.weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      window.addEventListener("load", () => {
        this.onLoad();
      });
      this.addEventListener("click", ({ target }) => {
        if (target.closest(".btn-store-favorite")) {
          this.storeSavingCookie(target.closest(".js-store-item"));
          this.displayPopupStore();
          this.buildLocationListLoad();
        }
        if (target.closest(".btn-store-clear-store")) {
          this.clearFavoriteStore(target.closest(".js-store-item"));
          this.displayPopupStore();
          this.buildLocationListLoad();
        }
      });
    }
    getTimeOpen() {
      const d = /* @__PURE__ */ new Date();
      let day = this.weekday[d.getDay()];
      if (day != "Saturday" || day != "Sunday") {
        day = "Days";
      }
      return day;
    }
    onLoad(variantId) {
      const productSelectId = variantId ? variantId : this.productSelect;
      if (window.location.pathname.includes("/products/")) {
        this.pageType = "products";
      } else {
        this.pageType = window.location.pathname.split("/")[1];
      }
      this.locationData = [];
      if (this.pageType == "products") {
        this.locationList = JSON.parse(document.getElementById("location-data").textContent) || [];
        this.locationGroup = Object.groupBy(this.locationList, ({ variantID }) => variantID);
        this.locationData = this.locationGroup[this.productSelect].length ? this.locationGroup[productSelectId] : this.locationList;
      } else if (this.pageType == "collections") {
        document.querySelectorAll(".js-btn-location").forEach((btn) => {
          btn.addEventListener("click", () => {
            const id = btn.querySelector(".btn-location").dataset.id;
            this.locationData = JSON.parse(btn.querySelector(`#${id}`)?.textContent) || [];
            this.buildLocationListLoad();
          });
        });
      }
      let { container } = this;
      this.mapConfig = JSON.parse(this.container.querySelector("#map-config").innerHTML);
      this.elms = {
        storeListContainer: this.querySelector(".js-store-list"),
        storeItemElements: this.querySelectorAll(".js-store-item"),
        searchForm: this.querySelector(".js-search-form")
      };
      this.markers = this.loadMarkers();
      this.initLocationFilter();
      this.buildLocationListLoad();
      this.backState();
      this.clearInput();
    }
    set open(value) {
      const popup = this.closest("popup-component");
      if (value) {
        this.closeAllCurrentPopups();
        popup.open();
      } else
        popup.close();
    }
    set refresh(sections) {
      const div = document.createElement("div");
      div.innerHTML = sections[this.sectionName];
      this.innerHTML = div.querySelector(this.tagName).innerHTML;
    }
    clearInput() {
      const inputField = this.querySelector(".map-search_zip");
      const btnClear = this.querySelector(".btn-clear");
      btnClear?.addEventListener("click", () => {
        inputField.value = "";
      });
    }
    closeAllCurrentPopups() {
      document.querySelectorAll("popup-component.active")?.forEach((popup) => {
        popup.close();
      });
    }
    initLocationFilter() {
      let { searchForm } = this.elms;
      searchForm.addEventListener("submit", (e) => {
        e.preventDefault();
        this.markers = this.arrangeAlphabetically(this.markers);
        let { zip, distance, country } = [...new FormData(searchForm).entries()].reduce((accu, value) => {
          accu[value[0]] = value[1];
          return accu;
        }, {});
        if (!zip.trim()) {
          alert(theme.strings.storeLocation.searchMessage);
          return;
        }
        let newZip = zip.toLowerCase().split(" ").join("");
        let matchingMarkerIndex = -1;
        this.markers.forEach((marker, index) => {
          const markerTitle = marker.properties.title.toLowerCase().split(" ").join("");
          const markerPostalCode = marker.properties.postal_code.toLowerCase().split(" ").join("");
          const markerCity = marker.properties.city.toLowerCase().split(" ").join("");
          if (newZip == markerTitle || newZip == markerPostalCode || newZip == markerCity) {
            matchingMarkerIndex = index;
          }
        });
        if (matchingMarkerIndex !== -1) {
          const matchingMarker = this.markers.splice(matchingMarkerIndex, 1)[0];
          this.markers.unshift(matchingMarker);
          this.hasResult = true;
          this.querySelector(".not-found").classList.add("d-none");
          this.querySelector(".store-availability-nearless-result").classList.remove("d-none");
          this.querySelector(".store-availability-nearless-result .js-input-value").innerHTML = `"${zip}"`;
        } else {
          this.querySelector(".store-availability-nearless-result").classList.add("d-none");
          this.querySelector(".not-found .key-search").innerHTML = `"${zip}"`;
          this.querySelector(".not-found").classList.remove("d-none");
          this.hasResult = false;
        }
        this.buildLocationList(zip);
      });
      const zipCode = new URLSearchParams(location.search).get("zip") || null;
      if (document.querySelector(".jsAutoSubmit") || new URLSearchParams(location.search).get("zip")) {
        this.elms.searchForm.querySelector('[name="zip"]').value = zipCode;
        this.elms.searchForm.dispatchEvent(new Event("submit"));
      }
    }
    backState() {
      this.querySelector(".btn-back")?.addEventListener("click", () => {
        this.markers = this.arrangeAlphabetically(this.markers);
        this.buildLocationListLoad();
        const btnClear = this.querySelector(".btn-clear");
        const inputField = this.querySelector(".map-search_zip");
        btnClear.classList.remove("active");
        inputField.value = "";
      });
    }
    loadMarkers() {
      let markersOdd = JSON.parse(document.getElementById("store-metaobject").textContent) || [];
      let markers = markersOdd.map((location2) => {
        const container = {};
        container["geometry"] = { "coordinates": [location2.latitude, location2.longitude] };
        container["properties"] = location2;
        return container;
      });
      markers.sort((a, b) => {
        const titleA = a.properties.title.toUpperCase();
        const titleB = b.properties.title.toUpperCase();
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
      markers = this.arrangeAlphabetically(markers);
      return markers;
    }
    arrangeAlphabetically(data) {
      data.sort((a, b) => {
        const titleA = a.properties.title.toUpperCase();
        const titleB = b.properties.title.toUpperCase();
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
      return data;
    }
    buildLocationListLoad() {
      this.querySelector(".store-availability-nearless").classList.add("d-none");
      let { storeListContainer } = this.elms;
      let template = storeListContainer.querySelector(".js-template");
      let storeSelectedId;
      let el;
      let temp;
      let tempArr = [];
      storeListContainer.innerHTML = template.outerHTML;
      const concordPickupID = 69052268710;
      const hoWrhouseID = 76854853798;
      let concordCombinedQuantity = 0;
      let concordPickupData = null;
      let hoWrhouseData = null;
      this.locationData.forEach((location2) => {
        if (location2.locationID === concordPickupID) {
          concordPickupData = location2;
          concordCombinedQuantity += location2.quantity || 0;
        } else if (location2.locationID === hoWrhouseID) {
          hoWrhouseData = location2;
          concordCombinedQuantity += location2.quantity || 0;
        }
      });
      this.markers.forEach((marker, index) => {
        let { properties, geometry } = marker;
        marker.id = properties["location_id"];
        if (this.pageType == "products" || this.pageType == "collections") {
          const storeID = properties["location_id"];
          if (storeID === hoWrhouseID) {
            return;
          }
          this.locationData.forEach((location2) => {
            const locationID = location2.locationID;
            if (locationID === hoWrhouseID) {
              return;
            }
            if (storeID == locationID) {
              storeSelectedId = this.getFavoriteStore;
              let displayQuantity = location2.quantity;
              if (locationID === concordPickupID && (concordPickupData || hoWrhouseData)) {
                displayQuantity = concordCombinedQuantity;
              }
              if (storeSelectedId == locationID) {
                temp = this.createStore(document.createElement("div"), { ...properties, Quantity: displayQuantity }, index);
                tempArr.push(temp);
                if (this.hasSpecial == "1") {
                  temp.querySelector(".js-store-status .has-special .special-order")?.classList.remove("d-none");
                } else if (this.productPrice > 5e4 || location2.locationName == "Concord") {
                  if (displayQuantity == 1) {
                    {
                      temp.querySelector(".js-store-status .not-show-quantity .verylowstock")?.classList.remove("d-none");
                    }
                  } else if (displayQuantity >= 2 && displayQuantity <= 5) {
                    {
                      temp.querySelector(".js-store-status .not-show-quantity .lowstock")?.classList.remove("d-none");
                    }
                  } else if (displayQuantity > 5) {
                    {
                      temp.querySelector(".js-store-status .not-show-quantity .instock")?.classList.remove("d-none");
                    }
                  } else {
                    temp.querySelector(".js-store-status .not-show-quantity .outstock")?.classList.remove("d-none");
                  }
                } else {
                  if (!displayQuantity || displayQuantity < 1) {
                    temp.querySelector(".js-store-status .show-quantity .outstock").classList.remove("d-none");
                  } else {
                    temp.querySelector(".js-store-status .show-quantity .instock").classList.remove("d-none");
                  }
                }
              } else {
                el = this.createStore(storeListContainer.appendChild(document.createElement("div")), { ...properties, Quantity: displayQuantity }, index);
                if (this.hasSpecial == "1") {
                  el.querySelector(".js-store-status .has-special .special-order")?.classList.remove("d-none");
                } else if (this.productPrice > 5e4 || location2.locationName == "Concord") {
                  if (displayQuantity == 1) {
                    {
                      el.querySelector(".js-store-status .not-show-quantity .verylowstock")?.classList.remove("d-none");
                    }
                  } else if (displayQuantity >= 2 && displayQuantity <= 5) {
                    {
                      el.querySelector(".js-store-status .not-show-quantity .lowstock")?.classList.remove("d-none");
                    }
                  } else if (displayQuantity > 5) {
                    {
                      el.querySelector(".js-store-status .not-show-quantity .instock")?.classList.remove("d-none");
                    }
                  } else {
                    el.querySelector(".js-store-status .not-show-quantity .outstock")?.classList.remove("d-none");
                  }
                } else {
                  if (!displayQuantity || displayQuantity < 1) {
                    el.querySelector(".js-store-status .show-quantity .outstock").classList.remove("d-none");
                  } else {
                    el.querySelector(".js-store-status .show-quantity .instock").classList.remove("d-none");
                  }
                }
              }
            }
            ;
          });
        }
      });
      if (tempArr.length) {
        storeListContainer.insertBefore(temp, storeListContainer.firstElementChild);
      }
    }
    buildLocationList(searchValue) {
      this.querySelector(".js-store-list").classList.remove("d-none");
      let { storeListContainer } = this.elms;
      let template = storeListContainer.querySelector(".js-template");
      let el;
      let jsNumberStore = this.querySelector(".js-number-store");
      let jsInputValue = this.querySelector(".js-input-value");
      let number = 0;
      storeListContainer.classList.remove("d-none");
      storeListContainer.innerHTML = template.outerHTML;
      jsInputValue.innerHTML = searchValue;
      const concordPickupID = 69052268710;
      const hoWrhouseID = 76854853798;
      let concordCombinedQuantity = 0;
      let concordPickupData = null;
      let hoWrhouseData = null;
      this.locationData.forEach((location2) => {
        if (location2.locationID === concordPickupID) {
          concordPickupData = location2;
          concordCombinedQuantity += location2.quantity || 0;
        } else if (location2.locationID === hoWrhouseID) {
          hoWrhouseData = location2;
          concordCombinedQuantity += location2.quantity || 0;
        }
      });
      this.markers.forEach((marker, index) => {
        let { properties, geometry } = marker;
        marker.id = properties["location_id"];
        const storeID = properties["location_id"];
        if (storeID === hoWrhouseID) {
          return;
        }
        this.locationData.forEach((location2, index2) => {
          const locationID = location2.locationID;
          if (locationID === hoWrhouseID) {
            return;
          }
          if (storeID == locationID) {
            number = ++number;
            let displayQuantity = location2.quantity;
            if (locationID === concordPickupID && (concordPickupData || hoWrhouseData)) {
              displayQuantity = concordCombinedQuantity;
            }
            el = this.createStore(storeListContainer.appendChild(document.createElement("div")), { ...properties, Quantity: displayQuantity }, index2);
            if (this.hasSpecial == "1") {
              el.querySelector(".js-store-status .has-special .special-order")?.classList.remove("d-none");
            } else if (this.productPrice > 5e4 || location2.locationName == "Concord") {
              if (displayQuantity == 1) {
                {
                  el.querySelector(".js-store-status .not-show-quantity .verylowstock")?.classList.remove("d-none");
                }
              } else if (displayQuantity >= 2 && displayQuantity <= 5) {
                {
                  el.querySelector(".js-store-status .not-show-quantity .lowstock")?.classList.remove("d-none");
                }
              } else if (displayQuantity > 5) {
                {
                  el.querySelector(".js-store-status .not-show-quantity .instock")?.classList.remove("d-none");
                }
              } else {
                el.querySelector(".js-store-status .not-show-quantity .outstock")?.classList.remove("d-none");
              }
            } else {
              if (!displayQuantity || ldisplayQuantity < 1) {
                el.querySelector(".js-store-status .show-quantity .outstock").classList.remove("d-none");
              } else {
                el.querySelector(".js-store-status .show-quantity .instock").classList.remove("d-none");
              }
            }
          }
        });
      });
      if (this.hasResult) {
        jsNumberStore.innerHTML = number;
      }
      this.querySelector(".store-availability-nearless").classList.remove("d-none");
    }
    createStore(el, properties, index) {
      let { storeListContainer } = this.elms;
      let template = storeListContainer.querySelector(".js-template");
      const address = (!!properties["Full Address"] ? [properties["Full Address"]] : [properties["address"], properties["province"], properties["postal_code"]].filter(Boolean)).join(", ");
      el.innerHTML = template.innerHTML.replace("{{ address }}", address).replaceAll("{{ url }}", properties["store_page"]).replaceAll("{{ name }}", properties["title"]).replaceAll("{{ address1 }}", properties["address"]).replaceAll("{{ state }}", properties["province"]).replaceAll("{{ phone }}", properties["phone"]).replaceAll("{{ phoneCall }}", properties["phone"].replaceAll(/[^0-9]/g, "")).replaceAll("{{ directions }}", properties["directions"]).replaceAll("{{ street }}", properties["street_view"]).replaceAll("{{ hoursWeekday }}", properties["hours_weekday"]).replaceAll("{{ hoursWeekend }}", properties["hours_weekend"]).replaceAll("{{ quantity }}", properties["Quantity"]);
      el.setAttribute("data-id", index);
      el.setAttribute("data-location-id", properties["location_id"]);
      el.classList.add("store-item", "js-store-item");
      el.classList.toggle("is-store-favorited", this.getFavoriteStore == +properties["location_id"]);
      return el;
    }
    storeSavingCookie(store) {
      const { localStorage } = theme;
      const locationID = store.getAttribute("data-location-id");
      localStorage("favoriteStore").set(locationID);
      document.querySelectorAll(".store-item.is-store-favorited")?.forEach((i) => {
        i.classList.remove("is-store-favorited");
      });
      document.querySelectorAll(`.store-item[data-location-id="${locationID}"]`).forEach((storeItem) => {
        storeItem.classList.add("is-store-favorited");
      });
    }
    storeSavingMetafield(store) {
      const locationID = store.getAttribute("data-location-id") + "";
      fetch(`${getCarToysApiUrl()}/api/customer-fields`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "selectYourStore": locationID
        })
      }).then((response) => response.json()).then((data) => {
        console.log(data);
      });
    }
    clearFavoriteStore(store) {
      const { localStorage } = theme;
      localStorage("favoriteStore").clear();
      store.classList.remove("is-store-favorited");
    }
    displayPopupStore(storeId, markers = this.markers) {
      if (storeId) {
        if (!storeId[0] || storeId[0] == "-1") {
          storeId = [];
        }
      } else {
        storeId = this.getFavoriteStore;
      }
      const selectStore = document.querySelectorAll(".header-select-store");
      if (!storeId.length) {
        selectStore.forEach((item) => {
          if (item.querySelector(".js-selected-store")) {
            item.classList.add("jsPopupSelectStore");
          }
          if (item.querySelector(".js-selected-store")) {
            if (item.classList.contains("jsHidden")) {
              item.style.visibility = "hidden";
            } else {
              item.querySelector(".js-selected-store").innerHTML = "Select my store";
            }
          }
          if (item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow")) {
            item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow").style.display = "none";
          }
          if (item.querySelector(".dropdown-hover-layer")) {
            item.querySelector(".dropdown-hover-layer").style.display = "none";
          }
        });
      }
      markers.forEach((marker, index) => {
        let { properties } = marker;
        marker.id = properties["location_id"];
        if (storeId && storeId[0]) {
          if (storeId[0] == properties["location_id"]) {
            selectStore.forEach((item, index2) => {
              if (item.querySelector(".js-selected-store")) {
                if (item.classList.contains("jsHidden")) {
                  item.style.visibility = "visible";
                }
                item.querySelector(".js-selected-store").innerHTML = `My store: ${properties["title"]}`;
                item.classList.remove("jsPopupSelectStore");
              }
              if (item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow")) {
                item.querySelector(".dropdown-hover-layer .header-select-store .icon-arrow").style.display = "block";
              }
              if (item.querySelector(".dropdown-hover-layer")) {
                item.querySelector(".dropdown-hover-layer").style.display = "block";
              }
              const address = (!!properties["Full Address"] ? [properties["Full Address"]] : [properties["address"], properties["city"], properties["province"], properties["country"]].filter(Boolean)).join(", ");
              if (item.querySelector(".dropdown-content")) {
                item.querySelector(".dropdown-content").innerHTML = item.querySelector(".dropdown-content").innerHTML.replaceAll("{{ url }}", properties["store_page"]).replaceAll("{{ name }}", properties["title"]).replaceAll("{{ address }}", address).replaceAll("{{ directions }}", properties["directions"]).replaceAll("{{ state }}", properties["province"]).replaceAll("{{ phone }}", properties["phone"]).replaceAll("{{ phoneCall }}", properties["phone"].replaceAll(/[^0-9]/g, "")).replaceAll("{{ hoursWeekday }}", properties["hours_weekday"]).replaceAll("{{ hoursWeekend }}", properties["hours_weekend"]);
              }
            });
          }
        }
      });
    }
    get getFavoriteStore() {
      const { localStorage } = theme;
      const value = localStorage("favoriteStore")?.get();
      return value;
    }
  };
  customElements.define("store-drawer-component", storeDrawerComponent);
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".jsStoreDrawer"))
      return;
    e.preventDefault();
    document.querySelector("store-drawer-component").open = true;
  });
})();
